import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-facebook-flat",
  "use": "icon-facebook-flat-usage",
  "viewBox": "0 0 16 31",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 31\" id=\"icon-facebook-flat\"><path d=\"M3.719 31V17.1h-3.72v-6.383h3.72V7.133C3.719 3.842 5.802 0 11.677 0c2.07 0 3.59.192 3.654.2l.624.08-.15 5.973-.687-.006c-.002 0-1.545-.014-3.228-.014-1.253 0-1.42.305-1.42 1.52v2.965H16l-.306 6.384H10.47V31zm5.354-1.38V15.722h5.287l.174-3.626h-5.46V7.752c0-1.435.333-2.9 2.814-2.9.997 0 1.944.005 2.553.01l.085-3.359a33.05 33.05 0 0 0-2.85-.124c-4.839 0-6.563 2.972-6.563 5.754v4.963H1.395v3.626h3.718V29.62z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol